// All monthly archives. Each entry: [date, h1, a1, pick1, odds1, ft1, h2, a2, pick2, odds2, ft2]
// ft may be single "2:1" or HT/FT "1:0 / 2:0" for 1/1 & 2/2 picks.
const RAW = [
  ["01.08.2026","Cobresal","Union La Calera","1","2.20","4:0","Ostrava","Slavia Prague","2","1.60","0:4"],
  ["02.08.2026","Hodd","Moss","1","2.25","2:1","Legia","Zaglebie","1","1.65","3:1"],

  ["01.07.2026","HJK","Ilves","1","1.70","2:1","Belgium","Senegal","Over 2.5","1.80","2:2"],
  ["02.07.2026","EBK","Abo","2","1.65","1:6","Lyn","Asane","1","1.75","6:2"],
  ["03.07.2026","FC Astana","Zhenis","1","1.75","1:0","Shelbourne","Dundalk","1","2.00","2:1"],
  ["04.07.2026","Ayr","Airdrieonians","1","1.70","2:1","Twente","Aberdeen","1","1.50","1:0"],
  ["05.07.2026","07 Vestur Sorvagur","HB Torshavn","2","1.55","1:4","VPS 2","Huima/Urho","1","1.90","3:1"],
  ["07.07.2026","Klaksvik","Bissen","1","1.50","2:1","JBK","Narpes Kraft","1","2.10","4:2"],
  ["08.07.2026","Nejmeh SC","Al Hikma","1","1.80","2:0","Ukraine U19","Germany U19","2","1.70","1:2"],
  ["09.07.2026","France","Morocco","1","1.60","2:0","NSI Runavik","Hamrun","1","2.10","1:1"],
  ["10.07.2026","Spain","Belgium","1","1.70","2:1","Villa Dalmine","Dock Sud","1","2.00","2:1"],
  ["11.07.2026","Tromso","Valerenga","1","1.80","4:0","Spartans","Arbroath","2","1.70","1:2"],
  ["12.07.2026","Rosenborg","Kristiansund","1","1.60","3:0","Malmo FF","Goteborg","1","1.90","4:0"],
  ["13.07.2026","Vestri","Fylkir","2","1.70","2:5","Djurgarden","Halmstad","1/1","1.80","2:0 / 3:0"],
  ["14.07.2026","La Fiorita","UNA Strassen","2","1.60","0:2","Grotta","Grindavik","1","2.10","1:2"],
  ["15.07.2026","GBK Kokkola","Narpes Kraft","1","2.20","6:2","Jippo","Mikkeli","1","1.60","3:1"],
  ["16.07.2026","Ilves","Differdange","1","1.65","3:1","FC Santa Coloma","Penybont","1","1.60","3:0"],
  ["17.07.2026","Bodo/Glimt","Fredrikstad","1/1","1.65","1:0 / 1:0","FCSB","FC Arges","1","1.60","2:0"],
  ["20.07.2026","Kopavogur","Vestri","1","1.60","6:2","Marienhamn","Lahti","2","1.55","0:2"],
  ["21.07.2026","Sabah Baku","KuPS","1","1.60","1:0","Mjallby","Lincoln Red Imps","1/1","1.80","3:0 / 3:0"],
  ["22.07.2026","Vardar","Riga FC","1X","1.65","2:3","Jaro 2","GBK Kokkola","Over 3.5","1.60","1:1"],
  ["23.07.2026","Qarabag","CSKA Sofia","1","1.60","0:0","Rakow","Valletta","1/1","1.60","0:1 / 3:1"],
  ["25.07.2026","Magni","KFG Gardabaer","Over 3.5","1.65","1:1","Mariehamn","AC Oulu","2","1.60","1:1"],
  ["26.07.2026","Lok. Plovdiv","Septemvri Sofia","1","1.70","2:1","HJK","TPS","1","1.50","1:0"],
  ["27.07.2026","Rosenborg","Fredrikstad","1","1.50","4:0","CFR Cluj","FC Voluntari","1","1.80","5:0"],
  ["28.07.2026","Shamrock Rovers","Ararat-Armenia","1","1.70","2:1","B36 Torshavn","AB Argir","1","1.60","1:0"],
  ["29.07.2026","Kauno Zalgiris","Klaksvik","1","1.90","1:0","H. Beer Sheva","Vikingur Reykjavik","1","1.80","2:0"],
  ["30.07.2026","Dinamo City","Aluminij","1","1.85","3:0","Valletta","Rakow","2","1.50","0:4"],

  ["01.06.2026","Levadia U19","Legion","Over 3.5","1.55","6:0","V. Haugesund","Asane 2","Over 3.5","1.70","3:1"],
  ["02.06.2026","Croatia","Belgium","BTS-YES","1.65","0:2","Assyriska FF","Enkoping SK","Over 2.5","1.55","4:2"],
  ["03.06.2026","Vasalund","Jarfalla","Over 2.5","1.50","3:1","Olympic","Lunds","Over 2.5","1.60","1:3"],
  ["04.06.2026","Andorra","Liechtenstein","1","1.55","2:0","AFC Eskilstuna","Karlbergs","BTS-YES","1.55","3:2"],
  ["05.06.2026","TWL Elektra","Horn","Over 3.5","1.80","1:5","Spain W","England W","1","1.60","4:0"],
  ["06.06.2026","SJK Akatemia 2","Narpes Kraft","Over 3.5","1.60","0:4","USA","Germany","BTS-YES","1.60","1:2"],
  ["07.06.2026","Morocco","Norway","BTS-YES","1.75","1:1","Ecuador","Guatemala","1/1","1.75","1:0 / 3:0"],
  ["08.06.2026","Norway U21","Finland U21","Over 2.5","1.55","0:2","France","Northern Ireland","1/1","1.60","1:0 / 3:1"],
  ["09.06.2026","Azerbaijan","San Marino","1/1","1.65","1:1 / 2:1","France W","Ireland W","1/1","1.70","1:0 / 1:0"],
  ["10.06.2026","Varberg","Norrby","1","1.65","2:0","Portugal","Nigeria","Over 2.5","1.60","2:1"],
  ["11.06.2026","Mexico","South Africa","1","1.50","2:0","Kubikenborgs","Lucksta","Over 2.5","1.60","3:1"],
  ["12.06.2026","Stenungsunds","Ahlafors IF","Over 2.5","1.55","0:4","Zalgiris","Riteriai","1/1","1.60","3:0 / 3:2"],
  ["13.06.2026","Grobina","RFS","2/2","1.70","0:2 / 1:3","Haiti","Scotland","2","1.60","0:1"],
  ["14.06.2026","Stromsgodset","Raufoss","1/1","1.65","2:1 / 6:1","Germany","Curacao","Over 3.5","1.65","7:1"],
  ["15.06.2026","Belgium","Egypt","1","1.60","1:1","KA Akureyri","Fram","Over 2.5","1.50","3:4"],
  ["16.06.2026","Stjarnan","Breidablik","Over 3.5","1.70","4:4","Al Sahel","Racing","1/1","1.70","1:0 / 2:0"],
  ["17.06.2026","Jelgava","Orge United","1","1.70","0:2","Enskede","Bollstanas","Over 2.5","1.55","3:1"],
  ["18.06.2026","Switzerland","Bosnia & Herzegovina","1","1.60","4:1","Eskilsminne","Trollhattan","Over 2.5","1.55","2:0"],
  ["19.06.2026","Tulevik","Levadia U19","Over 3.5","1.50","2:3","Hinna","Brodd","Over 3.5","1.50","3:3"],
  ["20.06.2026","Raeligen","Bjorkelangen","Over 3.5","1.65","3:1","Netherlands","Sweden","Over 2.5","1.75","5:1"],
  ["21.06.2026","Strommen","Stabaek","Over 2.5","1.50","1:0","Harstad","Kongsvinger 2","Over 3.5","1.55","6:1"],
  ["22.06.2026","Levadia U19","Johvi Phoenix","Over 3.5","1.55","2:0","Haugesund 2","Madla IL","Over 3.5","1.70","3:2"],
  ["23.06.2026","Inter Turku","SJK","1","1.65","1:1","Portugal","Uzbekistan","1/1","1.60","3:0 / 5:0"],
  ["24.06.2026","NSI Runavik","Klaksvik","BTS-YES","1.70","2:0","Bosnia & Herzg.","Qatar","1","1.50","3:1"],
  ["25.06.2026","Bjorkelangen","Sarpsborg 08 2","Over 3.5","1.70","2:0","Curacao","Ivory Coast","2/2","1.65","0:1 / 0:2"],
  ["26.06.2026","Senegal","Iraq","1/1","1.90","1:0 / 5:0","Flekkeroy","Akra","Over 3.5","1.60","5:1"],
  ["27.06.2026","Orkla","Molde 2","Over 3.5","1.55","4:1","Panama","England","2/2","1.70","0:0 / 0:2"],
  ["28.06.2026","Karlslund","Fittja","Over 2.5","1.50","2:2","South Africa","Canada","2","1.80","0:1"],
  ["29.06.2026","Akranes","Fram","Over 3.5","2.00","0:2","Germany","Paraguay","Over 2.5","1.75","1:1"],
  ["30.06.2026","Ivory Coast","Norway","BTS-YES","1.80","1:2","Nomme Utd U21","Flora U21","Over 3.5","1.65","3:3"],

  ["01.05.2026","Haugesund","Sandnes","1","1.80","2:0","Palermo","Catanzaro","1","1.80","3:2"],
  ["02.05.2026","Almere City","Den Bosch","1","1.65","3:0","Regensburg","Hoffenheim II","1","1.85","2:1"],
  ["03.05.2026","Espanyol","Real Madrid","2","1.80","0:2","Lillestrom","Sarpsborg 08","1","1.80","4:0"],
  ["04.05.2026","AS Roma","Fiorentina","1","1.60","4:0","Farnham","Gloucester","1","2.30","5:1"],
  ["05.05.2026","Al-Duhail","Al-Sadd","Over 3.5","2.20","1:4","Dunfermline","Arbroath","1","1.95","1:0"],
  ["06.05.2026","Zrinjski","Velez Mostar","1","1.90","1:0","Paide","Parnu JK Vaprus","1","1.65","2:0"],
  ["07.05.2026","Dinamo Tbilisi","Spaeri","1","1.85","2:1","Tukums 2000","Ogre United","1","1.70","6:1"],
  ["08.05.2026","Haka","Ekenas","1","1.65","4:3","St. Patricks","Waterford","Over 2.5","1.65","4:1"],
  ["09.05.2026","Sevilla","Espanyol","1","2.00","2:1","Waregem","Dender","1","1.70","2:1"],
  ["10.05.2026","Barcelona","Real Madrid","1","1.70","2:0","Genk","Westerlo","1","1.60","3:0"],
  ["11.05.2026","Napoli","Bologna","1","1.60","2:3","Tondela","Moreirense","1","1.90","2:0"],
  ["12.05.2026","Linfield","Dungannon","1","1.50","3:1","Kilmarnock","Dundee FC","1","1.70","3:1"],
  ["13.05.2026","Lens","PSG","2","2.00","0:2","Throttur","Breidablik","2","1.65","1:2"],
  ["15.05.2026","Aston Villa","Liverpool","Over 2.5","1.75","4:2","Al-Hidd","Al-Shabbab","1","1.75","1:0"],
  ["16.05.2026","Falkirk","Rangers","2","1.60","2:5","Radomiak Radom","Lech Poznan","2","1.80","1:3"],
  ["17.05.2026","Newcastle","West Ham","1","2.00","3:1","Genoa","AC Milan","2","1.70","1:2"],
  ["18.05.2026","Oddevold","Orebro","1","2.00","4:1","Fylkir","IR Reykjavik","1","1.55","2:1"],
  ["19.05.2026","Monza","Juve Stabia","1","1.85","2:1","Orgryte","Goteborg","2","1.75","2:3"],
  ["20.05.2026","Hammarby W","Malmo FF W","1","1.70","2:1","Ilves","Inter Turku","2","2.20","1:3"],
  ["21.05.2026","Gabala","Shamakhi","1","1.70","3:1","Anderlecht","St. Truiden","1","2.00","3:1"],
  ["22.05.2026","Osijek","Slaven Belupo","1","2.30","2:0","Trabzonspor","Konyaspor","1","2.00","2:1"],
  ["23.05.2026","Celta Vigo","Sevilla","1","1.85","1:0","Antwerp","Westerlo","1","1.90","2:0"],
  ["24.05.2026","West Ham","Leeds","1","1.75","3:0","Ajax","Utrecht","1","2.00","0:0"],
  ["26.05.2026","Herd","Aalesund 2","Over 3.5","1.70","0:2","St Etienne","Nice","Under 2.5","1.90","0:0"],
  ["27.05.2026","Tallinna Kalev","Viimsi JK","2","1.85","0:3","Jamaica","India","1","1.55","2:0"],
  ["28.05.2026","Septemvri Sofia","Yantra Gabrovo","1","1.80","2:1","Casa Pia","Torreense","1","2.30","2:0"],
  ["29.05.2026","Nomme Utd","Flora","2","1.50","0:4","Dundalk","Derry City","1","2.20","2:1"],
  ["30.05.2026","Latnitz","Treibach","1","1.80","4:2","Lahti","Ilves","1","2.25","5:0"],
  ["31.05.2026","Ranheim","Sandnes","1","1.90","5:1","Castellon","Eibar","1","1.50","2:1"],

  ["01.04.2026","Breitenrain","Kriens","2","1.80","0:2","Chelsea W","Arsenal W","1","2.10","1:0"],
  ["02.04.2026","Al-Fairsaly","Al Jubail","1","1.50","2:1","Las Palmas","Granada CF","1","1.70","2:0"],
  ["03.04.2026","Rayo Vallecano","Elche","1","1.75","1:0","Galway","Derry City","Over 2.5","2.15","2:1"],
  ["04.04.2026","Moreirense","Braga","2/2","2.30","0:1 / 0:1","Norrkoping","Varnamo","1","2.00","6:0"],
  ["05.04.2026","Inter","AS Roma","1","1.60","5:2","Stromsgodset","Stabaek","1","1.80","2:1"],
  ["06.04.2026","Lecce","Atalanta","2","1.65","0:3","Qarabag","Karvan","Over 3.5","1.80","7:0"],
  ["07.04.2026","Nordsjaelland","Brondby","1","2.00","2:1","Narva","Tammeka","1","1.90","3:0"],
  ["08.04.2026","Velez Mostar","Sloga Meridian","1","1.55","2:1","Goztepe","Galatasaray","2","1.75","1:3"],
  ["09.04.2026","Novi Pazar","Partizan","2","1.90","2:3","Rizespor","Samsunspor","Over 2.5","1.85","4:1"],
  ["10.04.2026","Charleroi","Antwerp","1","1.80","2:1","Waalwijk","FC Emmen","1","1.65","5:0"],
  ["11.04.2026","Dortmund","B. Leverkusen","Over 2.5","1.60","0:1","Burnley","Brighton","2","1.65","0:2"],
  ["12.04.2026","Lyon","Lorient","1","1.65","2:0","Bologna","Leece","1","1.85","2:0"],
  ["13.04.2026","Fredericia","Velje","Over 2.5","1.65","2:2","Renate","Pro Vercelli","1","2.15","2:1"],
  ["14.04.2026","Bolton","Stevenage","1","1.75","5:1","Varnamo","Sundsvall","1","1.85","3:0"],
  ["15.04.2026","AFC Wimbledon","Stockport County","2","1.70","0:2","Bravo","Primorje","1","1.60","2:1"],
  ["16.04.2026","Aston Villa","Bologna","1","1.60","4:0","AEK Athens","Rayo Vallecano","1","2.10","3:1"],
  ["17.04.2026","Fram","Keflavik","1","1.80","3:1","Almere City","Dordrecht","1","2.15","4:1"],
  ["18.04.2026","F. Amager","Helsingor","1","2.05","1:0","Reading","Cardiff","Over 2.5","1.70","1:3"],
  ["19.04.2026","Levadia","Flora","1","1.70","4:0","Padova","Reggiana","1","2.10","1:0"],
  ["20.04.2026","Den Bosch","Jong Utrecht","1","1.80","1:1","Dep. La Coruna","Mirandes","1","1.55","3:1"],
  ["21.04.2026","Inter","Como","1","1.90","3:2","Orn","Lyn 2","1","1.75","2:1"],
  ["22.04.2026","Radnik","Novi Pazar","1","2.15","2:0","KuPS","AC Oulu","Over 2.5","1.70","3:2"],
  ["23.04.2026","G.A. Eagles","AZ Alkmaar","Over 2.5","1.70","0:0","Sonderjyske","Midtjylland","2","1.55","1:2"],
  ["24.04.2026","Rosenborg 2","Aalesund 2","Over 3.5","1.70","5:0","Monza","Modena","1","1.65","1:0"],
  ["25.04.2026","Frosinone","Carrarese","1","1.55","3:0","Arsenal","Newcastle","1","1.50","1:0"],
  ["26.04.2026","Stuttgart","Werder Bremen","1","1.55","1:1","Tromso","Sandefjord","1","1.65","3:1"],
  ["27.04.2026","Ready","KFUM Oslo 2","1","1.75","2:0","Fram","Vestmannaeyjar","1","1.70","5:1"],
  ["28.04.2026","Valerenga U19","Kongsvinger U19","1","1.60","2:0","Mbarara City","Express","1","1.80","2:1"],
  ["29.04.2026","Al Nassr","Al Ahli SC","1","1.80","2:0","Graficar Beograd","Vojvodina","2","1.60","1:2"],
  ["30.04.2026","NK Bistrica","Bilje","1","1.70","3:0","JKT Tanzania","Kinondoni MC","1","1.55","1:0"],
];

function parseScore(s) {
  const [a, b] = s.split(":").map((x) => parseInt(x.trim(), 10));
  return [a, b];
}

export function settle(pick, ft) {
  const parts = ft.split("/").map((s) => s.trim());
  const p = pick.trim().toUpperCase();

  if (["1/1", "2/2", "1/2", "2/1", "1/X", "X/1", "2/X", "X/2"].includes(p)) {
    if (parts.length < 2) return "LOSS";
    const [htH, htA] = parseScore(parts[0]);
    const [ftH, ftA] = parseScore(parts[1]);
    const htR = htH > htA ? "1" : htH < htA ? "2" : "X";
    const ftR = ftH > ftA ? "1" : ftH < ftA ? "2" : "X";
    const [w1, w2] = p.split("/");
    return htR === w1 && ftR === w2 ? "WIN" : "LOSS";
  }

  const [h, a] = parseScore(parts[parts.length - 1]);
  const total = h + a;

  if (p === "1") return h > a ? "WIN" : "LOSS";
  if (p === "2") return a > h ? "WIN" : "LOSS";
  if (p === "X") return h === a ? "WIN" : "LOSS";
  if (p === "1X") return h >= a ? "WIN" : "LOSS";
  if (p === "X2" || p === "2X") return a >= h ? "WIN" : "LOSS";
  if (p.startsWith("OVER")) return total > parseFloat(p.replace("OVER", "")) ? "WIN" : "LOSS";
  if (p.startsWith("UNDER")) return total < parseFloat(p.replace("UNDER", "")) ? "WIN" : "LOSS";
  if (p.includes("BTS") || p.includes("BTTS")) return h > 0 && a > 0 ? "WIN" : "LOSS";
  return "LOSS";
}

function toISO(d) {
  const [dd, mm, yy] = d.split(".");
  return `${yy}-${mm}-${dd}`;
}

// Build structured rows (each = one day / one double)
export const ROWS = RAW.map((r) => {
  const [date, h1, a1, p1, o1, ft1, h2, a2, p2, o2, ft2] = r;
  const legs = [
    { home: h1, away: a1, pick: p1, odds: o1, ft: ft1, result: settle(p1, ft1) },
    { home: h2, away: a2, pick: p2, odds: o2, ft: ft2, result: settle(p2, ft2) },
  ];
  return { date, iso: toISO(date), legs };
}).sort((x, y) => (x.iso < y.iso ? 1 : x.iso > y.iso ? -1 : 0));

export function computeStats(rows) {
  let wins = 0, losses = 0;
  rows.forEach((row) =>
    row.legs.forEach((l) => {
      if (l.result === "WIN") wins += 1;
      else losses += 1;
    })
  );
  const total = wins + losses;
  const winRate = total ? Math.round((wins / total) * 100) : 0;
  return { wins, losses, total, winRate };
}

const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export function groupByMonth(rows) {
  const map = {};
  rows.forEach((row) => {
    const parts = row.iso.split("-");
    const yy = parts[0];
    const mm = parts[1];
    const key = `${yy}-${mm}`;
    if (!map[key]) map[key] = { key, label: `${MONTH_NAMES[parseInt(mm, 10) - 1]} ${yy}`, rows: [] };
    map[key].rows.push(row);
  });
  return Object.values(map).sort((a, b) => (a.key < b.key ? 1 : -1));
}

export function lastNDays(n) {
  return ROWS.slice(0, n);
}
